module.exports = __webpack_public_path__ + "img/mobile-banner11-ja.bc166bdc.jpg";